import React, { Component } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert, Spinner } from 'reactstrap';

import { Link } from "react-router-dom";

import { AuthAPI } from "api";

import {Utils, Loading} from "custom";

import { Turnstile } from '@marsidev/react-turnstile'

const md5 = require('md5');


class LoginForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            formEmail: '',
            formPassword: '',
            hidePsw: true,
            errors: false,
            loading: false,
            turnstilePassed: false
        };
    }

    onLoginPress(e) {

        let email = this.state.formEmail;
        let password = this.state.formPassword;

        let errors = {};

        if (password === "") {
            errors.password = "La password non può essere vuota";
        }

        if (email !== "" && !Utils.isValidEmail(email)) {
            errors.email = 'L\'email inserita non è valida';
        }
        if (email === "") {
            errors.email = 'Inserisci la tua email per continuare';
        }

        if (!this.state.turnstilePassed)
            errors.general = "Accesso Negato: devi verificare di non essere un robot"

        this.setState({errors: (Object.keys(errors).length > 0) ? errors : false});

        if (Object.keys(errors).length === 0) {
            const formData = new FormData(e.target);
            const turnstileToken = formData.get('cf-turnstile-response');

            this.setState({loading: true});
            AuthAPI.login({email: email, password: md5(password), turnstile_token: turnstileToken}).then((user) => {
                global.userData = user;

                if (user.role === "ADMIN") {
                    if (user.permissions.includes("DASHBOARD")) {
                        window.location.replace('/dashboard');
                        return;
                    }

                    if (user.permissions.includes("COURSE")) {
                        window.location.replace('/course');
                        return;
                    }

                    if (user.permissions.includes("REPORT")) {
                        window.location.replace('/network');
                        return;
                    }
                }

                if (user.role === "CONSULENT") {
                    window.location.replace('/dashboard');
                    return;
                }

                window.location.replace('/course');
            }).catch((error) => {
                console.error(error);
                this.setState({loading: false, formEmail: email, formPassword: ''});
                this.setState({
                    errors: {general: (error === 'SERVER_ERROR' || error === 'APP_ERROR') ? 'Si è verificato un errore di connessione' : ((error === "USER_INACTIVE") ? "Accesso Negato: utente non abilitato" : 'Accesso Negato: email o password errata')}
                });
            })
        }
    }


    render() {
        document.title = "Autenticazione | CLTV Cloud";

        let form = this.state.form;

        return <React.Fragment>
                    <div className="text-center mt-2">
                        <h5 className="text-primary">Benvenuto !</h5>
                        <p className="text-muted">Accedi con le tue credenziali.</p>
                    </div>
                    <div className="p-2 mt-4">
                        <Form
                            onSubmit={(e) => {
                                e.preventDefault();
                                this.onLoginPress(e)
                            }}
                            action="#">

                            <div className="mb-3">
                                <Label htmlFor="email" className="form-label">Email</Label>
                                <Input
                                    name="email"
                                    className="form-control"
                                    placeholder="Inserisci email"
                                    type="email"
                                    tabIndex={1}
                                    value={this.state.formEmail}
                                    invalid={this.state.errors.email}
                                    onChange={(text) => this.setState({formEmail: text.target.value})}
                                />
                                {(this.state.errors.email) ? <FormFeedback type="invalid">{this.state.errors.email}</FormFeedback> : null}
                            </div>

                            <div className="mb-3">
                                <div className="float-end" >
                                    <Link onClick={() => this.props.changeModeLogin()} className="text-muted">Password dimenticata?</Link>
                                </div>
                                <Label className="form-label" htmlFor="password-input">Password</Label>
                                <div className="position-relative auth-pass-inputgroup mb-3">
                                    <Input
                                        name="password"
                                        type={(this.state.hidePsw) ? "password" : "text"}
                                        tabIndex={2}
                                        className="form-control pe-5"
                                        placeholder="Inserisci Password"
                                        value={this.state.formPassword}
                                        invalid={this.state.errors.password}
                                        onChange={(text) => this.setState({formPassword: text.target.value})}
                                    />
                                    {(this.state.errors.password) ? <FormFeedback type="invalid">{this.state.errors.password}</FormFeedback> : null}
                                    <button className={"btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted " + (this.state.errors.general !== "undefined" ? ' me-3 ':' ') } type="button" onClick={() => this.setState({hidePsw: !(this.state.hidePsw)})}><i className="ri-eye-fill align-middle"></i></button>
                                </div>
                            </div>
                            <Turnstile onSuccess={() => this.setState({turnstilePassed: true})} siteKey={(process.env.REACT_APP_NODE_ENV === "development") ? "1x00000000000000000000AA" : process.env.REACT_APP_CLOUDFLARE_TURNSTILE_SITE_KEY} options={{ appearance: 'interaction-only' }} />
                            {(typeof this.state.errors.general !== "undefined") ? <Alert color="danger">{this.state.errors.general}</Alert> : null}
                            <div className="mt-4">
                                <Button tabIndex={3} color="success" className="btn btn-success w-100" type="submit">Accedi {(this.state.loading ? <Spinner size='sm' type='grow' /> : null)}</Button>
                            </div>
                        </Form>
                    </div>

        </React.Fragment>
    }
}

export default LoginForm;
